/* eslint-disable */
// VENDORED unchanged from learning_brain_poc/diagmap_layout.js (W7b / F3, POC commit 6ad5075e). Side-effect module: sets a window global.
// Diagnosis map layout, pure (no DOM): groups the /api/diagmap response into cards, folds columns by width (review R8),
// orders cards (barycentre) and cuts long columns behind 'Show N more' (R9). Loaded before diagmap.js.
// window.DiagMapLayout = {build, maxColumns, columnsWidth(n), UNFOLDED_PX, pathFrom, makeWords(TEXT), request(last, extra), resetRequest, scrub(text), cleanData(data),
// LIST_ONLY_BELOW_PX, COL}; no visible copy here. scrub() is the one internal-tag cleaner shared by the map, chat4*.js and rhs4.js.
(function () {
  'use strict';

  const COL = {PROBLEM: 0, Q1: 1, Q2: 2, Q3: 3, CAUSES: 4, CHECKS: 5, ROOT: 6};
  const COL_STEP_PX = 158;
  const COL_SLACK_PX = 8;
  const MIN_COLS = 2;
  const MAX_COLS = 7;
  const LIST_ONLY_BELOW_PX = 316;
  const CARDS_PER_COLUMN = 8;
  const ALWAYS_SHOWN = new Set(['leading', 'current_step', 'asking_now', 'ruled_out', 'on_path', 'observed']);
  const FILL_PRIORITY = {open: 0, asked_not_chosen: 1, not_traversed: 2};
  const STATE_PRIORITY = {leading: 0, current_step: 0, asking_now: 0, ruled_out: 1, on_path: 2, observed: 3, open: 4,
    asked_not_chosen: 5, not_traversed: 6};
  const LAST_PRIORITY = 9;
  const PATH_KINDS = new Set(['refines', 'answer', 'supports', 'weak_supports', 'rules_out', 'tests', 'identifies']);
  const LEFT_KINDS = new Set(['supports', 'weak_supports', 'refines']);
  const ANSWERED = new Set(['on_path', 'observed']);
  const MARK = {done: '✓', failed: '✗', current: '▶', pending: '○'};
  const STEP_STATUS = {observed: 'done', on_path: 'done', ruled_out: 'failed', current_step: 'current'};
  const DISPLAY_CAP = 0.95;
  const PERCENT = 100;
  // internal tags and ids that must never reach the screen; a real label in brackets such as '(general)' stays
  const ID_TOKEN_SRC = '\\b(?:PAT|F|SYM|DEC)_[A-Za-z0-9_]+\\b';
  const TAG_PAREN = new RegExp('\\s*\\((?=[^()]*(?:\\bQ\\d+\\b|\\bScope\\b|' + ID_TOKEN_SRC + '))[^()]*\\)', 'g');
  const CODE_PAREN = /\s*\(\s*[A-Z][A-Z0-9]*(?:_[A-Z0-9]+)+\s*\)/g;
  const Q_PREFIX = /(^|[\s([>])Q\d+\s*:\s*/g;
  const SCOPE_FRAGMENT = /\bScope\s+\d[\w.]*(?:\s*[·,]?\s*\d[\w.]*)*/gi;
  const ID_TOKEN = new RegExp(ID_TOKEN_SRC, 'g');
  const SEPARATOR = '·';

  function scrub(text) {
    let s = String(text === null || text === undefined ? '' : text)
      .replace(TAG_PAREN, '').replace(CODE_PAREN, '').replace(Q_PREFIX, '$1').replace(SCOPE_FRAGMENT, '').replace(ID_TOKEN, '')
      .replace(/\(\s*\)/g, '');
    if (s.includes(SEPARATOR)) s = s.split(SEPARATOR).map(p => p.trim()).filter(Boolean).join(' ' + SEPARATOR + ' ');
    return s.replace(/^[\s,;:]+/, '').replace(/[ \t]{2,}/g, ' ').replace(/[ \t]+([.,;:?!)])/g, '$1').trim();
  }

  // every string the map shows (labels, reasons, findings, tips, fixes, rule-out reasons) passes through scrub once
  const NODE_TEXT = ['label', 'reason', 'finding', 'tip', 'fix'];
  function cleanData(data) {
    if (!data || !Array.isArray(data.nodes)) return data;
    const fix = o => { const c = Object.assign({}, o); NODE_TEXT.forEach(k => { if (typeof c[k] === 'string') c[k] = scrub(c[k]); }); return c; };
    const stats = Object.assign({}, data.stats || {});
    if (Array.isArray(stats.ruled_out_overflow)) stats.ruled_out_overflow = stats.ruled_out_overflow.map(o => Object.assign({}, o, {label: scrub(o.label)}));
    return Object.assign({}, data, {nodes: data.nodes.map(fix), stats,
      edges: (data.edges || []).map(e => (typeof e.why === 'string' ? Object.assign({}, e, {why: scrub(e.why)}) : e))});
  }

  function maxColumns(width) {
    return Math.min(MAX_COLS, Math.max(MIN_COLS, Math.floor((width + COL_SLACK_PX) / COL_STEP_PX)));
  }
  // the width n columns need at their minimum size (the inverse of maxColumns); the map scrolls sideways instead of folding below it
  const columnsWidth = n => n * COL_STEP_PX - COL_SLACK_PX;
  const UNFOLDED_PX = columnsWidth(MAX_COLS);

  const byId = (a, b) => String(a).localeCompare(String(b), undefined, {numeric: true});
  const prio = n => (n && STATE_PRIORITY[n.state] !== undefined ? STATE_PRIORITY[n.state] : LAST_PRIORITY);

  function makeCards(nodes, isVisible) {
    const questions = new Map(), cards = [], causeCards = new Map(), checks = new Map();
    nodes.filter(n => n.type === 'question').forEach(q => {
      const c = {key: 'q:' + q.id, kind: 'question', level: Math.min(COL.Q3, Math.max(COL.Q1, q.column || COL.Q1)), head: q, chips: []};
      questions.set(q.id, c);
      cards.push(c);
    });
    let other = null;
    nodes.forEach(n => {
      if (n.type === 'symptom') cards.push({key: 's:' + n.id, kind: 'symptom', level: COL.PROBLEM, head: n, chips: []});
      else if (n.type === 'fact' && questions.has(n.parent)) questions.get(n.parent).chips.push(n);
      else if (n.type === 'fact' && (n.column || 0) >= COL.CHECKS) {
        if (!other) { other = {key: 'other', kind: 'other', level: COL.CHECKS, head: null, chips: []}; cards.push(other); }
        other.chips.push(n);
      } else if (n.type === 'fact') {
        cards.push({key: 'a:' + n.id, kind: 'answer', level: Math.min(COL.Q3, Math.max(COL.Q1, n.column || COL.Q1)), head: null, chips: [n]});
      } else if (n.type === 'cause') {
        const c = {key: 'c:' + n.id, kind: 'cause', level: COL.CAUSES, head: n, chips: [], steps: [], root: null};
        causeCards.set(n.id, c);
        cards.push(c);
      }
    });
    nodes.filter(n => n.type === 'step').sort((a, b) => (a.order || 0) - (b.order || 0)).forEach(s => {
      if (!checks.has(s.parent)) {
        const c = {key: 'k:' + s.parent, kind: 'checks', level: COL.CHECKS, head: null, chips: [], cause: s.parent, steps: []};
        checks.set(s.parent, c);
        cards.push(c);
      }
      checks.get(s.parent).steps.push(s);
    });
    nodes.filter(n => n.type === 'root_cause').forEach(r => {
      cards.push({key: 'r:' + r.id, kind: 'root', level: COL.ROOT, head: r, chips: [], cause: r.parent});
    });
    cards.forEach(c => {
      c.chips = c.chips.filter(isVisible);
      c.steps = (c.steps || []).filter(isVisible);
      const own = c.head ? isVisible(c.head) : false;
      c.visible = own || c.chips.length > 0 || c.steps.length > 0;
      c.items = [c.head, ...c.chips, ...c.steps].filter(Boolean);
    });
    return {cards: cards.filter(c => c.visible), causeCards};
  }

  function foldPlan(present, maxCols) {
    const target = {};
    Object.values(COL).forEach(l => { target[l] = l; });
    const fold = {root: false, checks: false};
    let count = present.size;
    const has = l => present.has(l);
    if (count > maxCols && has(COL.ROOT)) { fold.root = true; count--; }
    if (count > maxCols && has(COL.CHECKS)) { fold.checks = true; count--; }
    if (count > maxCols && has(COL.Q3) && (has(COL.Q2) || has(COL.Q1))) {
      const t = has(COL.Q2) ? COL.Q2 : COL.Q1;
      target[COL.Q3] = t;
      count--;
    }
    if (count > maxCols && has(COL.Q2) && has(COL.Q1)) {
      target[COL.Q2] = COL.Q1;
      if (target[COL.Q3] === COL.Q2) target[COL.Q3] = COL.Q1;
      count--;
    }
    if (count > maxCols && has(COL.PROBLEM) && (has(COL.Q1) || has(COL.Q2) || has(COL.Q3))) {
      target[COL.PROBLEM] = [COL.Q1, COL.Q2, COL.Q3].map(l => target[l]).filter(l => has(l)).sort()[0];
      count--;
    }
    return {target, fold};
  }

  function causeRank(a, b) {
    const grp = n => (n.state === 'leading' ? 0 : n.state === 'ruled_out' ? 2 : 1);
    return grp(a) - grp(b) || (b.confidence || 0) - (a.confidence || 0) || (a.rank || 0) - (b.rank || 0) || byId(a.id, b.id);
  }

  function barycentres(cards, edges, causeRow) {
    const out = new Map();
    edges.forEach(e => {
      if (!LEFT_KINDS.has(e.kind)) return;
      if (!out.has(e.from)) out.set(e.from, []);
      out.get(e.from).push(e.to);
    });
    const cardOfQuestion = new Map(cards.filter(c => c.kind === 'question').map(c => [c.head.id, c]));
    [COL.Q3, COL.Q2, COL.Q1, COL.PROBLEM].forEach(level => {
      cards.filter(c => c.level === level).forEach(c => {
        const vals = [];
        c.items.forEach(n => (out.get(n.id) || []).forEach(to => {
          if (causeRow.has(to)) vals.push(causeRow.get(to));
          else if (cardOfQuestion.has(to) && Number.isFinite(cardOfQuestion.get(to).bary)) vals.push(cardOfQuestion.get(to).bary);
        }));
        c.bary = vals.length ? vals.reduce((s, v) => s + v, 0) / vals.length : Infinity;
      });
    });
    cards.forEach(c => {
      if (c.kind === 'cause') c.bary = causeRow.get(c.head.id);
      else if (c.cause !== undefined) c.bary = causeRow.has(c.cause) ? causeRow.get(c.cause) : Infinity;
      else if (c.bary === undefined) c.bary = Infinity;
    });
  }

  const cardPrio = c => Math.min(...c.items.map(prio), LAST_PRIORITY);
  const cardAlways = c => c.items.some(n => ALWAYS_SHOWN.has(n.state));
  const cardFill = c => Math.min(...c.items.map(n => (FILL_PRIORITY[n.state] !== undefined ? FILL_PRIORITY[n.state] : 0)));
  const cardId = c => (c.head ? c.head.id : c.key);
  const display = (a, b) => (a.bary - b.bary) || (a.level - b.level) || (cardPrio(a) - cardPrio(b)) || byId(cardId(a), cardId(b));
  const fillOrder = (a, b) => (cardFill(a) - cardFill(b)) || (a.bary - b.bary) || byId(cardId(a), cardId(b));
  const finite = v => (Number.isFinite(v) ? v : Number.MAX_SAFE_INTEGER);

  function cutColumn(col, expanded) {
    const sorted = col.cards.slice().sort((a, b) => finite(a.bary) - finite(b.bary) || display(a, b));
    if (col.base === COL.CAUSES || expanded.has(col.key)) return {shown: sorted, more: []};
    const always = sorted.filter(cardAlways);
    const rest = sorted.filter(c => !cardAlways(c)).sort(fillOrder);
    const slots = Math.max(0, CARDS_PER_COLUMN - always.length);
    const keep = new Set([...always, ...rest.slice(0, slots)]);
    return {shown: sorted.filter(c => keep.has(c)), more: sorted.filter(c => !keep.has(c))};
  }

  // the unreached items the toggle really draws (cards cut behind 'Show N more' are not counted), per column key
  const drawnUnreached = col => col.shown.reduce((s, c) => s + c.items.filter(n => n.hidden_default).length, 0);
  function unreachedCounts(data, opts, model) {
    const shown = opts.showUnreached ? model : layout(data, Object.assign({}, opts, {showUnreached: true}));
    const by = new Map(shown.columns.map(col => [col.key, drawnUnreached(col)]));
    return {by, total: [...by.values()].reduce((s, v) => s + v, 0)};
  }

  function build(data, opts) {
    const model = layout(data, opts);
    const counts = unreachedCounts(data, opts, model);
    model.columns.forEach(col => { col.unreached = opts.showUnreached ? 0 : (counts.by.get(col.key) || 0); });
    model.unreachedTotal = counts.total;
    return model;
  }

  function layout(data, opts) {
    const width = opts.width;
    const showUnreached = !!opts.showUnreached;
    const expanded = opts.expanded || new Set();
    const nodes = (data && data.nodes) || [];
    const edges = (data && data.edges) || [];
    const isVisible = n => showUnreached || !n.hidden_default;
    const {cards, causeCards} = makeCards(nodes, isVisible);
    const maxCols = maxColumns(width);
    const present = new Set(cards.map(c => c.level));
    const {target, fold} = foldPlan(present, maxCols);
    const causes = cards.filter(c => c.kind === 'cause').map(c => c.head).sort(causeRank);
    const causeRow = new Map(causes.map((n, i) => [n.id, i]));
    barycentres(cards, edges, causeRow);

    let placed = cards;
    if (fold.checks) {
      cards.filter(c => c.kind === 'checks').forEach(c => { if (causeCards.has(c.cause)) causeCards.get(c.cause).steps = c.steps; });
      placed = placed.filter(c => c.kind !== 'checks' || !causeCards.has(c.cause));
    }
    if (fold.root) {
      cards.filter(c => c.kind === 'root').forEach(c => { if (causeCards.has(c.cause)) causeCards.get(c.cause).root = c.head; });
      placed = placed.filter(c => c.kind !== 'root' || !causeCards.has(c.cause));
    }
    causeCards.forEach(c => { c.items = [c.head, ...(c.steps || []), c.root].filter(Boolean); });

    const colMap = new Map();
    placed.forEach(c => {
      const base = target[c.level];
      if (!colMap.has(base)) colMap.set(base, {key: 'col' + base, base, levels: [], cards: []});
      const col = colMap.get(base);
      col.cards.push(c);
      c.indent = c.kind === 'question' || c.kind === 'answer' ? Math.max(0, c.level - base) : 0;
    });
    Object.keys(target).forEach(l => {
      const t = target[l];
      if (colMap.has(t) && !colMap.get(t).levels.includes(Number(l))) colMap.get(t).levels.push(Number(l));
    });
    const columns = [...colMap.values()].sort((a, b) => a.base - b.base).map(col => {
      const cut = cutColumn(col, expanded);
      return Object.assign(col, cut, {unreached: 0});
    });
    const columnOf = new Map(), hiddenByMore = new Map(), cardOf = new Map();
    columns.forEach(col => {
      col.cards.forEach(c => c.items.forEach(n => { columnOf.set(n.id, col.key); cardOf.set(n.id, c); }));
      col.more.forEach(c => c.items.forEach(n => hiddenByMore.set(n.id, col.key)));
    });
    return {
      width, maxCols, listOnly: width < LIST_ONLY_BELOW_PX, fold, columns, causes, columnOf, hiddenByMore, cardOf,
      visibleIds: new Set(nodes.filter(isVisible).map(n => n.id)),
      byId: new Map(nodes.map(n => [n.id, n])),
    };
  }

  function pathFrom(edges, id) {
    const fwd = new Map(), back = new Map();
    edges.forEach(e => {
      if (!PATH_KINDS.has(e.kind)) return;
      if (!fwd.has(e.from)) fwd.set(e.from, []);
      if (!back.has(e.to)) back.set(e.to, []);
      fwd.get(e.from).push(e.to);
      back.get(e.to).push(e.from);
    });
    const seen = new Set([id]);
    [fwd, back].forEach(adj => {
      const done = new Set([id]), queue = [id];
      while (queue.length) {
        const cur = queue.shift();
        (adj.get(cur) || []).forEach(nx => {
          if (done.has(nx)) return;
          done.add(nx);
          seen.add(nx);
          queue.push(nx);
        });
      }
    });
    return seen;
  }

  // ---------- words (pure; all visible copy comes from diagmap.js TEXT) ----------
  function makeWords(TEXT) {
    const stepStatus = n => STEP_STATUS[n.state] || 'pending';
    const stepMark = n => MARK[stepStatus(n)];
    const pct = c => Math.round(Math.min(Number(c) || 0, DISPLAY_CAP) * PERCENT);
    const stateWords = n => (n.type === 'step' ? TEXT.step[stepStatus(n)] : TEXT.state[n.state] || '');
    const accName = n => (TEXT.type[n.type] || '') + ', ' + stateWords(n) + ': ' + n.label;
    const fixWord = r => TEXT.fix[r.fix_kind] || TEXT.fixDefault;
    const evidence = e => (e.book && !e.seen ? TEXT.documented : e.wins > 0 ? TEXT.seenWon(e.seen, e.wins) : TEXT.seenNever(e.seen || 0));
    const isEvidence = e => e.kind === 'supports' || e.kind === 'weak_supports';

    function tipLines(data, byId, n) {
      const lines = [n.label, (TEXT.type[n.type] || '') + ': ' + stateWords(n)];
      if (n.tip && n.tip.toLowerCase() !== stateWords(n).toLowerCase()) lines.push(n.tip);
      if (n.type === 'cause' && n.state !== 'ruled_out' && typeof n.confidence === 'number') lines.push(TEXT.confidence(pct(n.confidence)));
      if (n.reason && !data.edges.some(e => e.kind === 'rules_out' && e.to === n.id)) lines.push(n.reason);
      if (n.finding) lines.push(n.finding + (n.via === 'text' ? ' (' + TEXT.readFromMessage + ')' : ''));
      if (n.type === 'root_cause' && n.fix) lines.push(fixWord(n) + n.fix);
      data.edges.forEach(e => {
        if (e.from !== n.id && e.to !== n.id) return;
        const other = byId.get(e.from === n.id ? e.to : e.from);
        if (!other) return;
        if (isEvidence(e) && e.from === n.id) lines.push(other.label + ': ' + evidence(e));
        if (e.kind === 'rules_out' && e.why) lines.push(TEXT.ruledBy + e.why);
        if (e.kind === 'refines' && e.to === n.id) lines.push(TEXT.follows + other.label);
      });
      return lines;
    }

    function listLines(data, model) {
      const out = [], vis = n => model.visibleIds.has(n.id), nodes = data.nodes, edges = data.edges;
      const syms = nodes.filter(n => n.type === 'symptom' && vis(n));
      if (syms.length) out.push(TEXT.listProblem + syms.map(n => n.label).join('; '));
      model.causes.forEach(c => {
        const conf = c.state !== 'ruled_out' && typeof c.confidence === 'number' ? ', ' + TEXT.confidence(pct(c.confidence)).toLowerCase() : '';
        const parts = [TEXT.type.cause + ' ' + c.label + ': ' + stateWords(c) + conf + '.'];
        const by = edges.filter(e => e.to === c.id && isEvidence(e)).map(e => model.byId.get(e.from))
          .filter(n => n && vis(n) && ANSWERED.has(n.state)).map(n => n.label);
        parts.push(by.length ? TEXT.listReached + by.join('; ') + '.' : TEXT.listNoAnswers);
        const why = edges.filter(e => e.kind === 'rules_out' && e.to === c.id && e.why).map(e => e.why);
        if (why.length) parts.push(TEXT.ruledBy + why.join('; ') + '.');
        else if (c.state === 'ruled_out' && c.reason) parts.push(c.reason + '.');
        const steps = nodes.filter(s => s.type === 'step' && s.parent === c.id).sort((a, b) => (a.order || 0) - (b.order || 0));
        if (steps.length) parts.push(TEXT.listChecks + steps.map(s => stepMark(s) + ' ' + s.label + ' (' + TEXT.step[stepStatus(s)] + ')').join('; ') + '.');
        const rc = nodes.find(r => r.type === 'root_cause' && r.parent === c.id);
        if (rc) parts.push(TEXT.rootCause + rc.label + '.' + (rc.fix ? ' ' + fixWord(rc) + rc.fix : ''));
        out.push(parts.join(' '));
      });
      const now = nodes.filter(n => n.type === 'question' && n.state === 'asking_now');
      if (now.length) out.push(TEXT.listAskedNow + now.map(n => n.label).join('; '));
      const linked = new Set(edges.filter(isEvidence).map(e => e.from));
      const other = nodes.filter(n => n.type === 'fact' && ANSWERED.has(n.state) && !linked.has(n.id));
      if (other.length) out.push(TEXT.listOther + other.map(n => n.label).join('; '));
      const over = (data.stats && data.stats.ruled_out_overflow) || [];
      if (over.length) out.push(TEXT.overflow(over.length) + ': ' + over.map(o => o.label).join('; '));
      return out;
    }

    return {stepStatus, stepMark, pct, stateWords, accName, tipLines, listLines};
  }

  // ---------- request body (review 7.1); ruled-out order is kept per chat ----------
  let ruledOrder = [];
  // extra = {patterns, excluded, confidence} of every cause the chat has shown (chat4_pc.js); without it only this turn's cards are drawn
  function request(last, extra) {
    if (!last || !last.decision) return null;
    const cards = last.cards || [], observed = last.observed || [], ruled = last.ruled_out || [];
    if (!observed.length) ruledOrder = [];
    ruled.forEach(p => { if (!ruledOrder.includes(p)) ruledOrder.push(p); });
    const confidence = Object.assign({}, extra && extra.confidence);
    cards.forEach(c => { if (typeof c.post === 'number') confidence[c.pid] = c.post; });
    const dp = last.diag_path || {};
    const patterns = extra && extra.patterns && extra.patterns.length ? extra.patterns : cards.map(c => c.pid);
    const excluded = [...new Set([...cards.filter(c => c.excluded).map(c => c.pid), ...((extra && extra.excluded) || [])])].filter(p => patterns.includes(p));
    return {
      patterns, ruled_out: ruledOrder.filter(p => ruled.includes(p)), observed,
      asked: last.asked || [], pending: last.pending || [],
      // keys of the questions put in this chat: with BRAIN_OPENING_FACTS_SOFT the server tells read facts from answered ones as the planner does
      asked_keys: [...new Set((last.asked_log || []).map(e => e && e.key).filter(k => typeof k === 'string' && k))],
      step: last.step && last.step.pid ? {pid: last.step.pid, key: last.step.key} : null,
      step_results: last.step_results || {}, leader: dp.pid || null, identified: !!dp.identified,
      excluded, confidence,
    };
  }

  function resetRequest() { ruledOrder = []; }

  window.DiagMapLayout = {build, maxColumns, columnsWidth, UNFOLDED_PX, pathFrom, makeWords, request, resetRequest, scrub, cleanData, LIST_ONLY_BELOW_PX, COL};
})();
